// import moment from "moment";
import axios from "axios";
import { url } from "../../src/Values/constants";
import {
    showSnackbarAction
} from "../Redux/actions";
import axiosHandler from "./axiosHandler";

export const createFAQ = async (
    organization_id: string,
    question: string,
    answer: string,
    dispatcher: any,
    setLoad: (data: boolean) => void,
    uid: any,
    authToken: any,
    history: any
) => {

    try {

        let apiData = {
            organization_id,
            question,
            answer,
            created_by: uid,
            modified_by: uid
        }
        // axios.defaults.headers.common['x-access-token'] = authToken;
        let res = await axiosHandler.post(url + '/faq/create', apiData);
        dispatcher(
            showSnackbarAction(res.data.message, "success")
        );
        setLoad(false);
        history.push('/faqs');
    } catch (error: any) {
        dispatcher(
            showSnackbarAction(error.response.data.message, "error")
        );
        setLoad(false);
    }
};

export const fetchFAQ = async (
    organization_id: string,
    setFAQ: (data: any[]) => void
) => {
    try {
        let apiData: any = {
            organization_id,
        };
        const res: any = await axiosHandler.get(url + '/faq/fetchAll', {
            params: apiData,
        });
        console.log("resd", res)
        setFAQ(res.data.data);
    } catch (error) {
        console.log("FAQs fetch Error", error);
        setFAQ([]);
    }
};

export const deleteFAQ = async (
    id: any,
    dispatcher: any,
    history: any,
    authToken: any,
) => {
    try {
        // axios.defaults.headers.common['x-access-token'] = authToken;

        const res = await axiosHandler.post(url + '/faq/delete', {id: id});

        dispatcher(showSnackbarAction(res.data.message, 'success'));
        window.location.reload();

    } catch (error: any) {
        dispatcher(showSnackbarAction(error.response.data.message, 'error'));
        // history.push('/faq');
    }
};

export const updateFAQ = async (
    question: any,
    answer: any,
    uid: any,
    id: any,
    dispatcher: any,
    setLoad: (data: boolean) => void,
    history: any,
    authToken: any
) => {
    try {
        let apiData = {
            data: {
                question,
                answer,
                modified_by: uid
            },
            id
        }
        // axios.defaults.headers.common['x-access-token'] = authToken;
        const res = await axiosHandler.put(url + '/faq/update', apiData);
        dispatcher(showSnackbarAction(res.data.message, 'success'));
        setLoad(false);
        history.push('/faqs');
    } catch (error: any) {
        dispatcher(
            showSnackbarAction(error.response.data.message, "error")
        );
        setLoad(false);
    }
};